<form [formGroup]="form" (ngSubmit)="submitted.next()" novalidate>
  <p class="h7-bold gmt-24 gmb-12 gmb-md-16">
    {{ 'RESULTS.ADD.MEASUREFAT' | translate }}
  </p>
  <button
    type="button"
    (click)="openModal()"
    class="btn b3-semibold btn-link m-0 gmb-16 gmb-md-32 p-0 text-decoration-none"
    gptDataTrack="analyses-bfp-instructions"
  >
    {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.BUTTON_LABEL' | translate }}
  </button>

  <div
    *ngIf="error?.status === 400"
    class="gp-alert gp-alert-danger p3-regular mb-4"
  >
    <span *ngIf="configuration.id === AnalysisId.FatPercentageMale">
      {{ 'FAILURE.BAD_REQUEST.BFP_MALE' | translate }}
    </span>
    <span *ngIf="configuration.id === AnalysisId.FatPercentageFemale">
      {{ 'FAILURE.BAD_REQUEST.BFP_FEMALE' | translate }}
    </span>
    <span></span>
  </div>

  <div
    *ngFor="let control of controlArray; let index = index"
    class="gmb-16 gmb-sm-0 d-inline-flex"
    [ngClass]="{
      'w-50': control.meta.halfWidth,
      'w-100': !control.meta.halfWidth,
      'gpr-12': control.meta.halfWidth && !control.meta.unitIndex,
      'gpl-12': control.meta.halfWidth && control.meta.unitIndex
    }"
  >
    <gpu-form-field
      class="gpu-wrapper-reserved"
      [appearance]="formFieldAppearance"
    >
      <gpu-label>
        {{ control.meta.metric.name }} ({{ control.meta.unit.name }})
      </gpu-label>
      <input
        type="text"
        gpuInput
        gpuLocalNumber
        [id]="control.meta.metric.id + '|' + control.meta.unit.id"
        [formControl]="control"
        [name]="'controlName'"
        [placeholder]="'ANALYSES.SINGLE.VALUE' | translate"
        [focused]="index === 0"
        [appMobileScrollOnFocus]="index === 0"
        (blur)="trackInput($event, control.meta.metric.id)"
      />
      <gpu-error *ngIf="control.errors?.required">
        {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
      </gpu-error>
      <gpu-error *ngIf="control.errors?.pattern">
        {{ 'ANALYSES.VALUE_INVALID' | translate }}
      </gpu-error>
      <gpu-error *ngIf="control.errors?.min">
        {{ 'MIN_VALUE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="control.errors?.max">
        {{ 'MAX_VALUE' | translate }}
      </gpu-error>
    </gpu-form-field>
  </div>

  <app-measurement-add-buttons
    [formValid]="form.valid"
    [editMode]="editMode"
    [isLoading]="false"
  ></app-measurement-add-buttons>
</form>
